import React, { useCallback, useState, useEffect } from 'react';
import { connect } from "react-redux";
import TabPanel, { Item } from 'devextreme-react/tab-panel';
// import DxTabPanel, { Item } from "devextreme-react/tab-panel";
import InventorySearchForm from './InventorySearchForm.js';
import { useHistory } from 'react-router-dom';

const allTabs = [
  {
    ID: 1,
    Title: 'Item'
  },
  {
    ID: 2,
    Title: 'Lot'
  },
  {
    ID: 3,
    Title: 'Sublot'
  },
];
const Inventory = (props) => {
  const [selectedTabIndex, _setSelectedTabIndex] = useState(() => {
    // If the user previously selected a tab this session, restore it
    const saved = sessionStorage.getItem('wm_inventory_selectedTabIndex');
    if (saved !== null) {
      const idx = parseInt(saved, 10);
      if (idx >= 0 && idx < allTabs.length) return idx;
    }
    // Otherwise fall back to the default tab from profile settings
    if (props.oidc?.user?.profile?.hasOwnProperty("WMDEFAULTINVENTORYITEMSTAB")) {
      const defaultTab = props.oidc.user.profile.WMDEFAULTINVENTORYITEMSTAB;
      const tabIndex = allTabs.findIndex(tab => tab.Title === defaultTab);
      return tabIndex >= 0 ? tabIndex : 0;
    }
    return 0;
  });
  const setSelectedTabIndex = useCallback((val) => {
    _setSelectedTabIndex(val);
    sessionStorage.setItem('wm_inventory_selectedTabIndex', val);
  }, []);

  useEffect(() => {
    // Only apply the profile default if the user hasn't explicitly picked a tab this session
    const saved = sessionStorage.getItem('wm_inventory_selectedTabIndex');
    if (saved !== null) return;
    if (props.oidc?.user?.profile?.hasOwnProperty("WMDEFAULTINVENTORYITEMSTAB")) {
      const defaultTab = props.oidc.user.profile.WMDEFAULTINVENTORYITEMSTAB;
      const tabIndex = allTabs.findIndex(tab => tab.Title === defaultTab);
      if (tabIndex >= 0) {
        setSelectedTabIndex(tabIndex);
      }
    }
  }, [props.oidc?.user]); // Watch the entire user object instead of just the nested property

  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
    }
  }, []);


  return (
    <div>
      {/* <TabPanel
        dataSource={tabs}
        itemTitleRender={renderTitle}
        deferRendering={false}
        showNavButtons={true}
        selectedItem={selectedTab}
        repaintChangesOnly={true}
        onSelectionChanged={onSelectionChanged}
        itemComponent={(data) => (
          <InventorySearchForm selectedTab={selectedTab} {...data} permission={props.ReceiptReducer.rolePermissions} accessToken={props.oidc.user.access_token} />
        )}
      /> */}
      <TabPanel key={selectedTabIndex} onOptionChanged={onTabSelectionChanged} selectedIndex={selectedTabIndex}>
        {allTabs.map((m, i) => (
          <Item key={i} title={m.Title}>
            <InventorySearchForm selectedTab={m.Title} />
          </Item>
        ))}
      </TabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(Inventory);